import axios from "../axios-auth";

export const userService = {
  login,
  getUserList,
  getUsersByShopId,
  saveUser,
  getUserDetail,
  getAllRoles,
  changePasswordById,
  changePassword,
  getAllCaisher,
  getUsersByRoleAndStatus,
  getAllMarketing,
  getUserRoleList
};

function login(user) {
  return axios.post("/login", user);
}

function getUserList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.role) {
    params["role"] = searchParams.role;
  }

  return axios.get("/auth/users", { params });
}

function saveUser(user) {
  if (user.id) {
    //edit
    return axios.put("/auth/updateuser", user);
  } else {
    // create new
    return axios.post("/auth/user", user);
  }
}

function changePasswordById(user) {
  let obj = {
    id: user.id,
    newPassword: user.password
  };
  return axios.put("/auth/change-password-by-id", obj);
}

function changePassword(user) {
  let obj = {
    oldPassword: user.oldPassword,
    newPassword: user.newPassword
  };
  return axios.put("/auth/change-password-by-current-user", obj);
}

function getUserDetail(id) {
  return axios.get("/auth/user/" + id);
}

function getAllRoles() {
  return axios.get("/auth/roles");
}

function getUsersByShopId(id) {
  return axios.get("/auth/user-by-shop-id/" + id);
}

function getAllCaisher() {
  return axios.get("/auth/cashiers");
}

function getUsersByRoleAndStatus(role, status) {
  return axios.get("/auth/user-by-role-status/" + role + "/" + status);
}

function getAllMarketing() {
  return axios.get("/auth/marketings");
}

function getUserRoleList() {
  return axios.get("/auth/user-roles/");
}